module.exports = __webpack_public_path__ + "img/swift.cf738bdb.png";